import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// Material UI imports
import { Box } from '@mui/material';
// Component imports
import QuestionHeader from '../../components/questionHeader';
import CustomTextField from '../../components/customTextField';
// Utility imports
import { fetchSiteCoreContents } from '../../utility/utils';

const InfectionOther = ({
  contentID,
  handleInfectionOtherChange,
  infectionOtherText,
  movePlaceholder,
}) => {
  const [questionTextValue, setQuestionTextValue] = useState('');
  const [questionImageURLValue, setQuestionImageURLValue] = useState('');
  const [questionResponseTextValue, setQuestionResponseTextValue] = useState(
    ''
  );

  useEffect(() => {
    if (!contentID) return;
    fetchSiteCoreContents(contentID)
      .then((typeContent) => {
        const woundCharacteristics =
          typeContent?.item?.contentDetailsLists?.[0]?.contentItems?.[0]
            ?.woundCharacteristics || {};
        const {
          question2Text = '',
          question2Image = '',
          question2ResponseText = '',
        } = woundCharacteristics;

        setQuestionResponseTextValue(
          question2ResponseText.replace(/<[^>]+>/g, '')
        );
        setQuestionImageURLValue(question2Image);
        setQuestionTextValue(question2Text.replace(/<[^>]+>/g, ''));
      })
      .catch((error) => {
        console.error('Failed to fetch site core contents:', error);
      });
  }, [contentID]);

  return (
    <Box>
      <QuestionHeader
        questionTextValue={questionTextValue}
        questionImageURLValue={questionImageURLValue}
        showInfo={false}
      />

      <CustomTextField
        inputVariant="outlined"
        inputType="text"
        handleChange={handleInfectionOtherChange}
        inputValue={infectionOtherText}
        placeHolderText={questionResponseTextValue}
        inputStyle={{ width: '100%', maxWidth: '573px' }}
        movePlaceholder={movePlaceholder}
      />
    </Box>
  );
};

InfectionOther.propTypes = {
  contentID: PropTypes.string.isRequired,
  handleInfectionOtherChange: PropTypes.func.isRequired,
  infectionOtherText: PropTypes.string.isRequired,
  movePlaceholder: PropTypes.bool.isRequired,
};

export default InfectionOther;
